import { create } from 'zustand';
import type { Coordinates } from '@/types';

/**
 * State for a "shared location" pin — a specific point that arrived via a
 * `?ll=<lat>,<lng>` link (or was dropped by the Share flow). Self-contained,
 * non-persisted store in the spirit of trafficStore / isochroneStore.
 *
 * When `pin` is set, SharedLocationMarker drops a marker and SharedLocationCard
 * shows the coordinates + a "Directions to here" action.
 */
interface SharedLocationState {
  pin: Coordinates | null;
  setPin: (coordinates: Coordinates | null) => void;
  clearPin: () => void;
}

export const useSharedLocationStore = create<SharedLocationState>((set) => ({
  pin: null,
  setPin: (pin) => set({ pin }),
  clearPin: () => set({ pin: null }),
}));
